module.exports = __webpack_public_path__ + "img/2.a37a7626.jpg";